import { render, staticRenderFns } from "./zubair-sec.vue?vue&type=template&id=aa90deb0&"
import script from "./zubair-sec.vue?vue&type=script&lang=js&"
export * from "./zubair-sec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports